import { render, staticRenderFns } from "./shortVideoDetail.vue?vue&type=template&id=08f5c060&scoped=true"
import script from "./shortVideoDetail.vue?vue&type=script&lang=js"
export * from "./shortVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./shortVideoDetail.vue?vue&type=style&index=0&id=08f5c060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5c060",
  null
  
)

export default component.exports